import { PageContainer } from "@volca/ui/components/ui/page-components";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { OverviewSkeleton } from "@/profitability/overview/overview-skeleton";

/**
 * The agent page before its name is in: the header row the period will
 * fill, and the dashboard under it. The real header lands in the same row.
 */
export const AgentPageSkeleton = () => (
  <Stack gap={8} align="stretch" className="w-full" aria-busy role="status">
    <span className="sr-only">Loading agent</span>
    <Stack
      direction="row"
      align="start"
      justify="between"
      gap={4}
      className="w-full flex-wrap gap-y-3"
      aria-hidden
    >
      <Stack gap={1} className="min-w-0 flex-1 basis-96">
        <Stack direction="row" align="center" gap={3} wrap className="min-w-0">
          <Skeleton className="h-10 w-72 max-w-full" />
          <Skeleton className="h-9 w-36" />
        </Stack>
        <Skeleton className="h-5 w-64 max-w-full" />
      </Stack>
      <Stack direction="row" align="center" gap={2} className="pt-2">
        <Skeleton className="h-9 w-28" />
        <Skeleton className="h-9 w-24" />
        <Skeleton className="h-9 w-9" />
      </Stack>
    </Stack>
    <OverviewSkeleton />
  </Stack>
);

/** The agent page while the agent itself is still loading. */
export const AgentPagePending = () => (
  <PageContainer variant="document">
    <AgentPageSkeleton />
  </PageContainer>
);
